export default "__VITE_PUBLIC_ASSET__e21a1c38__"